<script setup lang="ts">
    // @ts-expect-error raison: lib externe mal typée
    import { defineExpose } from "vue";
    import { ref } from 'vue';
    import OnboardingGroupeComponent from "../onboarding-groupe/components/OnboardingGroupeComponent.vue";

    const isOpened = ref(false);
    const collectivite = ref(null as any);
    let promise: Promise<boolean>;
    let resolvePromise: any;
    let rejectPromise: any;

    async function open(_collectivite: any) {
        collectivite.value = _collectivite;
        promise = new Promise((resolve, reject) => {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        isOpened.value = true;
        return await promise;
    }

    function onClose() {
        resolvePromise(false);
    }

    function onProspectsImported(datas: any) {
        resolvePromise(datas);
        isOpened.value = false;
    }

    defineExpose({ open, close });
</script>

<template>
    <custom-modal v-model:show="isOpened" @closed="onClose" :classesNames="'modal-fullscreen'">
        <template #header>&nbsp;</template>
        <div>
            <onboarding-groupe-component :is-widget-mode="false" :collectivite="collectivite" @completed="onProspectsImported" />
        </div>
        <template #footer>&nbsp;</template>
    </custom-modal>
</template>
